/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

/*COMPONENT*/

/*REDUX*/
import { setLayerWOgeojson } from "../../App/actions/layerActions";

/*PICTURE*/
import icon_map_editor from "../../Assets/svg/icon_map_editor.svg";
import icon_analyze_lite from "../../Assets/svg/icon_analyze_lite.svg";

/*FUNCTION*/
import formatDate from "../../App/validation/format-date";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

class FormListRender extends Component {
  state = {
    modalBilling: false,
  };

  setLayerWOgeojson = (geo_layer) => {
    const content = {
      geo_layer: geo_layer,
    };
    this.props.setLayerWOgeojson(content);
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state

    //global props
    const { form_list } = this.props;

    return (
      <main>
        {form_list.map((geo_layer, idx) => {
          const { _id, name, date, date_created, geo_project } = geo_layer;
          const geo_project_name = geo_project?._id
            ? geo_project.name
            : dict["project has been deleted"][language];
          return (
            <main
              className="container_project background_white outline_grey"
              key={idx}
              style={{ verticalAlign: "top" }}
            >
              <div
                className="badge margin_right margin_bottom green_container"
                style={{
                  display: "inline-block",
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: "100%",
                  boxSizing: "border-box",
                }}
              >
                {geo_project_name}
              </div>

              <section>
                <p
                  className="text_bold"
                  style={{
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  title={name}
                >
                  {name}
                </p>
                <p className="text_small">
                  {date_created && (
                    <>
                      {dict["Created at"][language]}:{formatDate(date_created)}
                    </>
                  )}
                </p>
              </section>

              <section
                style={{
                  position: "absolute",
                  bottom: 5,
                  boxSizing: "border-box",
                  width: "calc( 100% - 30px )",
                  padding: 0,
                }}
              >
                <div
                  style={{
                    backgroundColor: "transparent",
                    borderTop: "2px solid #e6e6e6",
                    marginBottom: 5,
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    alignItems: "flex-start",
                  }}
                >
                  <section
                    id="part_1"
                    style={{ flex: 1, paddingRight: "10px" }}
                  >
                    <p className="text_small margin_bottom">
                      {date && (
                        <>
                          {dict["Modified at"][language]}:{formatDate(date)}
                        </>
                      )}
                    </p>
                    <br />
                    <p className={`badge margin_bottom blue_container`}>FORM</p>
                  </section>

                  <section id="part_2" style={{ width: "50px" }}>
                    <Link to={`/form_editor/${_id}`}>
                      <div
                        className="text_below_icon"
                        style={{
                          marginRight: "15px",
                          textAlign: "center",
                          width: "100%",
                        }}
                      >
                        <img src={icon_map_editor} height="25px" alt="Editor" />
                        <p style={{ margin: 0 }}>Edit</p>
                      </div>
                    </Link>
                  </section>

                  <section id="part_3" style={{ width: "50px" }}>
                    <Link to={`/view/${geo_project?.link}?layer_id=${_id}`}>
                      <div
                        className="text_below_icon"
                        style={{
                          textAlign: "center",
                          width: "100%",
                        }}
                      >
                        <img
                          src={icon_analyze_lite}
                          height="25px"
                          alt="Viewer"
                        />
                        <p style={{ margin: 0 }}>View</p>
                      </div>
                    </Link>
                  </section>
                </div>
              </section>
            </main>
          );
        })}
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
});

export default connect(mapStateToProps, { setLayerWOgeojson })(FormListRender);
